import './ProgressIndicator.scss';

interface ProgressIndicatorProps {
    text?: string;
}

function ProgressIndicator({ text = 'Loading' }: ProgressIndicatorProps) {
  return (
    <div role="status" className="progress-indicator">
      <p className="progress-indicator__text">{text}</p>
      <span className="progress-indicator__dot progress-indicator__dot--first" />
      <span className="progress-indicator__dot progress-indicator__dot--second" />
      <span className="progress-indicator__dot progress-indicator__dot--third" />
    </div>
  );
}

export default ProgressIndicator;
